<template>
  <div class="self-stretch flex-col gap-2 flex" v-if="new_style">
    <template v-for="(field,index) in fields" :key="field.id">
      <template v-if="isFieldForSidebar(field)">
        <template v-if="hasFeature('field-access-levels')">
          <template v-if="!settings.use_field_access_levels || field.type === 'FieldGroup'">
            <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" />
          </template>
          <template v-else-if="settings.use_field_access_levels">
            <template v-if="field.type !== 'FieldGroup'">
              <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" v-if="hasAccessLevel(field, 'edit_access', current_user)"  />
              <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" v-if="hasAccessLevel(field, 'readonly_access', current_user)"  />
            </template>
          </template>
        </template>
        <template v-else>
          <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" />
        </template>
      </template>
    </template>
  </div>

  <template v-else>
    <div v-for="(field,index) in fields" :key="field.id">
      <dl v-if="isFieldForSidebar(field)">
        <template v-if="hasFeature('field-access-levels')">
          <template v-if="!settings.use_field_access_levels || field.type === 'FieldGroup'">
            <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" />
          </template>
          <template v-else-if="settings.use_field_access_levels">
            <template v-if="field.type !== 'FieldGroup'">
              <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" v-if="hasAccessLevel(field, 'edit_access', current_user)"  />
              <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" v-if="hasAccessLevel(field, 'readonly_access', current_user)"  />
            </template>
          </template>
        </template>
        <template v-else>
          <fields-display-sidebar :index="index" :cst="cst" :form="form" :form_result="form_result" :field="field" :form_preview="form_preview" />
        </template>
      </dl>
    </div>
  </template>
</template>
<script>
import { computed } from 'vue'
import FieldsDisplaySidebar from '../../common/fields/_fields_display_sidebar.vue';
import { hasAccessLevel } from '../../common/index_js.js'
import { useAuthStore } from '../../stores/auth_store';
import {contactSubTypes} from "../../stores/contact_sub_types";

export default{
  components: { FieldsDisplaySidebar },
  props: {
    ccst: {type: Object, required: true},
    customFields: {type: Boolean, default: true},
    new_style: {type: Boolean, default: false}
  },
  data: ()=>({
    // double implementation of app/assets/angular/components/contact/dropdown/item/contextual-popover/contextual_popover.vue
    // migrate to form once form is in vue
    form_result: {},
    form_preview: true,
    form: {},
    cst: {},
    hasAccessLevel,
    current_user: {},
    settings: {},
  }),
  computed: {
    params(){
      const {cst, form_result, field} = this
      return {cst, form_result, field}
    },
    allFields(){ return this.ccst.contact_sub_type.field_group.fields},
    fields(){
      let fields = this.allFields
      if (!this.customFields){
        fields = fields.slice(0, 3)
      }
      return fields
    }
  },
  provide() {
    return {
      allFields:  computed(() => this.allFields),
      formResult: computed(()=> this.form_result),
    }
  },
  created(){
    useAuthStore().authUser().then(u=>this.current_user = u)

    this.form_result  = this.ccst.form_result;

    this.form_preview = true
    if (this.customFields) this.initializeCstFormResult(null, this.allFields)
    this.ccst.contact_sub_type.options ||= {}
    this.form = this.ccst.contact_sub_type
    contactSubTypes().settings(this.form.uid).then(data=> this.settings = data)
  },
  methods: {
    isFieldForSidebar(field){
      if(field.type === 'FieldGroup'){
        return field.fields.find(f => { return f.datahash.sidebar})
      } else {
        return this.customFields ? field.datahash.sidebar : true
      }
    },
    // original params in angular: (null, ccst.contact_sub_type.field_group.fields)=>(contact_sub_type_id, fields, cst)
    initializeCstFormResult(contact_sub_type_id, fields, cst){
      // this.fields = fields;
      this.initializedCstFormResult = true;
      this.cst = cst || { id: contact_sub_type_id };

      if (this.form_result
          && this.form_results
          && this.form_result.contact_sub_type_id !== contact_sub_type_id) {
        const idx = this.form_results.findIndex(r=>r.contact_sub_type_id === this.form_result.contact_sub_type_id)

        this.form_results.splice(idx, 1);
      } else {
        if (this.form_result) return; // Don't do it twice
      }
    }
  }
}
</script>